export default "__VITE_ASSET__p6T9S_aA__"